import { ErrorHandler, Injectable } from '@angular/core';
import { isLazyChunkLoadError, recoverFromChunkLoadError } from './chunk-load-recovery';

/** Catches Angular-internal lazy-load failures and triggers cache-bypass recovery. */
@Injectable()
export class ChunkLoadRecoveryErrorHandler implements ErrorHandler {
    handleError(error: unknown): void {
        if (isLazyChunkLoadError(error)) {
            void recoverFromChunkLoadError();
            return;
        }

        console.error(error);
    }
}
